import request from 'client/utils/request'

export default function saveUserColors(colors) {
  return request.post('user/colors', {
    account_colors: {
      value: colors,
    },
  })
}
